"use client";

import { LoadingSpinner } from "@/components/ui/loading";

/**
 * Loading component specifically for client access checking
 * Displays a loading spinner with appropriate message while checking access permissions
 */
export function ClientAccessLoading() {
  return <LoadingSpinner message="Checking access permissions..." />;
}
